import React, { useContext, useEffect, useState } from 'react'

import { Box, Text, Grid } from "grommet"
import Spinner from '../../common/Spinner'
import SSH from '../../common/SSH'
// import Metrics from '../../common/Metrics'
import Warn from '../../common/Warn'
import TTJsonTree from '../../common/TTJsonTree'
import TTCopyClipboard from '../../common/TTCopyClipboard'
import Icinga from '../../common/Icinga'
import Splunk from '../../common/Splunk'

import { gql, useQuery } from '@apollo/client';

// import HealthStatusServiceHostMetrics from './HealthStatusServiceHostMetrics'
import HealthStatusServiceHostActions from './HealthStatusServiceHostActions'

import ShowServiceHistory from '../../history/ShowServiceHistory'
import VersionHistory from '../../version/VersionHistory'

import UserContext from '../../../context/UserContext'

import * as moment from "moment-timezone"
import * as beautify from "json-beautify"

import TimeAgo from 'react-timeago'
import { useMatch } from 'react-router-dom'
import { AWSStats, CombinedStats } from './HealthStatusServiceComponents'
import { AWS_VIEW } from '../HealthStatusNodesTab'
import { CHEF_NODE_POLL_INTERVAL } from '../../../utils/pollIntervals'

const NODE_QUERY = gql`
query ($nodeName: String!) {
    node(where: {name: {_eq: $nodeName}}) {
        name
        ip
        serviceGroup_nodes {
            source
            chef
            timestamp
            serviceGroup {
                group
            }
        }
        environment {
            name
        }
    }
}
`

const NODE_QUERY_SPECIFIC = gql`
query ($nodeName: String!, $serviceGroup: String!) {
    node(where: {name: {_eq: $nodeName}, serviceGroup_nodes: {serviceGroup: {group: {_eq: $serviceGroup}}}}) {
        name
        ip
        serviceGroup_nodes {
            source
            chef
            timestamp
            serviceGroup {
                group
            }
        }
        environment {
            name
        }
    }
}
`

const HealthStatusNodeChef = ({ nodeSelected, serviceGroupSelected = "" }) => {

    const token = useContext(UserContext)

    // Get the servicegroup if found
    const locationChef = useMatch("/health/:tab/:serviceGroupName/chef/:nodeName")
    if (locationChef && locationChef.params && locationChef.params.serviceGroupName && serviceGroupSelected.length === 0) {
        serviceGroupSelected = locationChef.params.serviceGroupName
    }

    const result = useQuery(
        serviceGroupSelected.length > 0 ? NODE_QUERY_SPECIFIC : NODE_QUERY,
        serviceGroupSelected.length > 0 ? {
            variables: { nodeName: nodeSelected, serviceGroup: serviceGroupSelected }, pollInterval: CHEF_NODE_POLL_INTERVAL
        } : {
            variables: { nodeName: nodeSelected }, pollInterval: CHEF_NODE_POLL_INTERVAL
        }
    )

    // const [marketNames, setmarketNames] = useState([])
    // useEffect(() => {
    //     if (!result.loading &&
    //         result.data &&
    //         result.data.node &&
    //         result.data.node.length > 0 &&
    //         result.data.node[0] &&
    //         result.data.node[0].serviceGroup_nodes.length > 0 &&
    //         result.data.node[0].serviceGroup_nodes[0].chef &&
    //         result.data.node[0].serviceGroup_nodes[0].chef.price_server &&
    //         result.data.node[0].serviceGroup_nodes[0].chef.price_server.exchanges) {
    //         setmarketNames(Object.keys(result.data.node[0].serviceGroup_nodes[0].chef.price_server.exchanges))
    //     }
    // }, [result.loading, result.data])

    const [chefTime, setchefTime] = useState('')
    useEffect(() => {
        if (!result.loading &&
            result.data &&
            result.data.node &&
            result.data.node.length > 0 &&
            result.data.node[0] &&
            result.data.node[0].serviceGroup_nodes.length > 0) {

            let chefTimeTemp = ''

            if (!result.data.node[0].serviceGroup_nodes[0].timestamp.includes('+00:00')) {
                chefTimeTemp = moment(moment(result.data.node[0].serviceGroup_nodes[0].timestamp).format('YYYY-MM-DD HH:mm:ss.SSS') + " +0000").tz('UTC').format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
            } else {
                chefTimeTemp = result.data.node[0].serviceGroup_nodes[0].timestamp
            }

            chefTimeTemp = moment(chefTimeTemp).tz(token.timezone).format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
            setchefTime(chefTimeTemp)
        }
    }, [result.loading, result.data, token.timezone])

    const [mdsConsumer, setmdsConsumer] = useState(false)
    useEffect(() => {
        if (!result.loading && result.data && result.data.node && result.data.node.length > 0 &&
            result.data.node[0] && result.data.node[0].serviceGroup_nodes.length > 0 &&
            result.data.node[0].serviceGroup_nodes[0].chef &&
            result.data.node[0].serviceGroup_nodes[0].chef.mds
        ) {
            setmdsConsumer(true)
        }
    }, [result.loading, result.data])

    if (result && result.loading) {
        return (
            <Spinner />
        )
    }

    return (
        <Box
            fill
            flex={false} background='light-1'>
            {result && result.data && result.data.node &&
                result.data.node.length > 0 && result.data.node[0].serviceGroup_nodes.length === 0 &&
                <Box direction="row" margin={{ bottom: "5px", top: "10px", left: "20px", right: "20px" }}>
                    <Warn warning={!AWS_VIEW.includes(serviceGroupSelected) ? "No Chef Data Found" : "No AWS Data Found"} />
                </Box>
            }
            {result && result.data && result.data.node &&
                result.data.node.length > 0 && result.data.node[0].serviceGroup_nodes.length > 0 &&
                result.data.node[0].serviceGroup_nodes[0].chef &&
                <Box flex={false}>
                    <Box flex={false} direction="row" pad="none" gap="xxsmall" align="start" justify="center" alignContent="center" alignSelf="start">

                        <Box
                            direction="row"
                            alignSelf="center" alignContent="center"
                            flex={false}
                        >

                            <Box>
                                <Text color="brand"
                                    size="small" weight="bold" margin="none">{nodeSelected}</Text>
                            </Box>
                            <TTCopyClipboard copyText={nodeSelected} />

                            <Text color="dark-3" size="small" margin="none">{result.data.node[0].ip}</Text>
                            <TTCopyClipboard copyText={result.data.node[0].ip} />

                        </Box>

                        {
                            result.data.node[0].serviceGroup_nodes[0].source === "chef" &&
                            <Box wrap={true} direction="row" gap="small" height="55px">
                                <SSH ip={result.data.node[0].ip} />
                                {/* <Metrics host={result.data.node[0].name} env={result.data.node[0].environment.name} ip={result.data.node[0].ip} service="general" /> */}
                                <ShowServiceHistory
                                    host={result.data.node[0].name}
                                    env={result.data.node[0].environment.name}
                                    service={serviceGroupSelected}
                                    instance={""}
                                    mdsConsumer={mdsConsumer}
                                />
                                <Icinga env={result.data.node[0].environment.name} nodename={result.data.node[0].name} />
                                <Splunk env={result.data.node[0].environment.name} hostname={result.data.node[0].name} />
                                <VersionHistory
                                    host={result.data.node[0].name}
                                />
                            </Box>
                        }




                    </Box>

                    <Grid
                        rows={['100%', '100%']}
                        columns={['28%', '72%']}
                        gap="0px"
                        flex
                        areas={[
                            { name: 'left', start: [0, 0], end: [0, 0] },
                            { name: 'right', start: [1, 0], end: [1, 0] },
                        ]}
                    >

                        <Box gridArea="right">
                            <Box margin={{ top: "xsmall" }} direction="row-responsive" wrap gap="xsmall">
                                {!result.loading && result && result.data &&
                                    result.data.node.length > 0 &&
                                    result.data.node[0] &&
                                    result.data.node[0].serviceGroup_nodes.length > 0 &&
                                    result.data.node[0].serviceGroup_nodes[0].chef.versions &&
                                    Object.keys(result.data.node[0].serviceGroup_nodes[0].chef.versions).sort((a, b) => (a > b) ? 1 : -1).map(k =>
                                        <Box key={k} flex={false} direction="row" margin={{ top: "xsmall", bottom: "xsmall" }} pad="xxsmall" background="light-1" align="start" alignSelf="start" alignContent="start" round="xsmall">
                                            <Text color="dark-3" size="xsmall" margin="none" textAlign="start" weight="bold"> {k} </Text>
                                            <Text color="dark-3" size="xsmall" margin="none" textAlign="start">&nbsp;{result.data.node[0].serviceGroup_nodes[0].chef.versions[k].split('|')[0]}</Text>
                                        </Box>
                                    )
                                }
                            </Box>

                            {result.data.node[0].serviceGroup_nodes[0].source === "aws" &&
                                <AWSStats
                                    awsdata={result.data.node[0].serviceGroup_nodes[0].chef}
                                />
                            }

                            {result.data.node[0].serviceGroup_nodes[0].source === "chef" &&
                                <CombinedStats
                                    env={""}
                                    service_name={""}
                                    zk_start_time={""}
                                    ip={""}
                                    serviceGroup={result.data.node[0].serviceGroup_nodes[0].serviceGroup.group}
                                    node={result.data.node[0].name}
                                />
                            }

                            <Box margin={{ top: "3px" }} direction="row-responsive" wrap gap="xsmall">
                                {mdsConsumer &&
                                    <Box flex={false} direction="row" margin={{ top: "xsmall", bottom: "xsmall" }} pad="xxsmall" background="light-1" align="start" alignSelf="start" alignContent="start" round="xsmall">
                                        <Text color="dark-3" size="xsmall" margin="none" textAlign="start">{"MDS Consumer:"}&nbsp;</Text>
                                        <Box direction="row" wrap gap="small">
                                            {!result.loading && result &&
                                                result.data && result.data.node &&
                                                result.data.node.length > 0 &&
                                                result.data.node[0] &&
                                                result.data.node[0].serviceGroup_nodes.length > 0 &&
                                                result.data.node[0].serviceGroup_nodes[0].chef && result.data.node[0].serviceGroup_nodes[0].chef.mds &&
                                                Object.keys(result.data.node[0].serviceGroup_nodes[0].chef.mds).sort().map(consumer_name => (
                                                    <Text key={consumer_name} color="ttok" size="xsmall" margin="none" textAlign="start" weight="bold">{consumer_name}</Text>
                                                ))
                                            }
                                        </Box>
                                    </Box>
                                }
                            </Box>
                        </Box>

                        {result.data && result.data.node &&
                            <Box gridArea="left">
                                <Box flex={false} direction="row" pad="xxsmall" gap="none" align="start" justify="center" alignContent="center" alignSelf="start">
                                    <HealthStatusServiceHostActions
                                        host={result.data.node[0].name}
                                        env={result.data.node[0].environment.name}
                                        behindHA={false}
                                    />
                                </Box>
                            </Box>
                        }
                    </Grid>

                    <Box border="bottom" margin={{ top: "xsmall" }}>
                    </Box>

                    <Box flex={false} direction="row" pad="xsmall" gap="xxsmall" align="center" justify="center" alignContent="center" alignSelf="start">
                        {
                            result.data && result.data.node && result.data.node[0] &&
                            result.data.node[0].serviceGroup_nodes && result.data.node[0].serviceGroup_nodes[0] &&
                            result.data.node[0].serviceGroup_nodes[0].source === "chef" &&
                            <Text name="chefData" color="dark-3" size="small" margin="none" weight="bold">Chef Data</Text>
                        }
                        {
                            result.data && result.data.node && result.data.node[0] &&
                            result.data.node[0].serviceGroup_nodes && result.data.node[0].serviceGroup_nodes[0] &&
                            result.data.node[0].serviceGroup_nodes[0].source === "aws" &&
                            <Text name="awsData" color="dark-3" size="small" margin="none" weight="bold">AWS Data</Text>
                        }

                        <TTCopyClipboard copyText={beautify(result.data.node[0].serviceGroup_nodes[0].chef, null, 2, 80)} />
                        {chefTime && <Text color="dark-3" size="xsmall" margin="none"> Last Chef Run: <TimeAgo date={chefTime} /> on {chefTime}</Text>}
                    </Box>

                    <TTJsonTree data={result.data.node[0].serviceGroup_nodes[0].chef} />

                    {/* {result.data && result.data.node && result.data.node[0].serviceGroup_nodes[0].chef.human_readable !== 'Edgeproxy' &&
                        <Box>
                            < HealthStatusServiceHostMetrics
                                metrics_key={'Chef-' + result.data.node[0].name}
                                service={result.data.node[0].serviceGroup_nodes[0].chef.human_readable}
                                host={result.data.node[0].name}
                                env={result.data.node[0].environment.name}
                                ip={result.data.node[0].ip}
                                trade_interface_ip={result.data.node[0].serviceGroup_nodes[0].chef.trade_interface_ip}
                                variables={{
                                    marketNames: marketNames
                                }}
                                source={result.data.node[0].serviceGroup_nodes[0].source}
                            />
                        </Box>
                    } */}
                </Box>
            }
        </Box>
    )
}

export default HealthStatusNodeChef
